module.exports = __webpack_public_path__ + "img/在途跟踪.7ad372f2.svg";